export default "__VITE_ASSET__e4f794eb__"